import { InjectionToken } from '@angular/core';
import { DevToolsRegistry } from '../../dev-tools';
import { FeatureProvidersRegistry } from '@core/shared/feature';
import { take } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../../dev-tools";
export const FEATURE_PROVIDERS = /*#__PURE__*/new InjectionToken("Feature Providers");
export let FrontendFeatureProvidersRegistry = /*#__PURE__*/(() => {
  class FrontendFeatureProvidersRegistry extends FeatureProvidersRegistry {
    constructor(providers, debug) {
      super(providers);
      debug.exposeDebugFunction(['Features', 'Inspect Providers'], () => {
        return this.registry$.pipe(take(1));
      });
    }
    static {
      this.ɵfac = function FrontendFeatureProvidersRegistry_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FrontendFeatureProvidersRegistry)(i0.ɵɵinject(FEATURE_PROVIDERS), i0.ɵɵinject(i1.DevToolsRegistry));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FrontendFeatureProvidersRegistry,
        factory: FrontendFeatureProvidersRegistry.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FrontendFeatureProvidersRegistry;
})();